import { takeEvery, call, put } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import callAdapter from '@/utils/sagaHelper';
import actions from '../constants';
import DatasetReportsService from '../service';
import {
  dataModelReportDownloadError,
  dataModelReportDownloadSuccess,
  fetchDataModelReportsError,
  fetchDataModelReportsSuccess,
} from '../actions';

export function* dataModelReports(action) {
  const { category, code } = action;
  const { response, error } = yield call(callAdapter, DatasetReportsService.dataModelReports(code));
  if (error) {
    yield put(fetchDataModelReportsError(category, code, error));
  } else {
    yield put(fetchDataModelReportsSuccess(category, code, response));
  }
}

export function* dataModelReportDownload(action) {
  const {
    code,
    downloadFile,
    report,
  } = action;
  const { response, error } = yield call(
    callAdapter,
    DatasetReportsService.dataModelReportDownload(code, report.id),
  );
  if (error) {
    yield put(dataModelReportDownloadError(
      'downloads',
      code,
      report,
      error,
      downloadFile,
    ));
  } else {
    yield put(dataModelReportDownloadSuccess('downloads', code, report, response));
    if (downloadFile) {
      saveAs(new Blob([response]), report.name);
    }
  }
}

export default function* dataModelReportsApi() {
  yield takeEvery(actions.FETCH_DATA_MODEL_REPORTS, dataModelReports);
  yield takeEvery(actions.DATA_MODEL_REPORT_DOWNLOAD, dataModelReportDownload);
}
